<template>
  <div>
    <section class="content">
      <v-layout justify-center>
        <v-container fluid grid-list-md>
          <v-alert
            :value="showConnectionError"
            type="error"
          >Couldn't Connect to Post Service! Please Comeback Later!</v-alert>
          <v-layout row wrap>
            <v-flex md12 xs12 sm12>
              <v-card class="pa-2">
                <v-layout row wrap>
                  <v-flex xs12 md3 sm6>
                    <v-autocomplete
                      filled
                      :items="campaignList"
                      label="Campaign"
                      item-value="id"
                      hide-details
                      item-text="name"
                      v-model="filter.campaignId"
                      v-if="showCampaignPosts"
                    >
                    </v-autocomplete>
                    <v-text-field
                      :hide-details="true"
                      v-model="filter.campaignName"
                      :height="56"
                      label="Filter by Campaign"
                      outlined
                      v-on:keyup.enter="searchPosts"
                      v-else
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3 sm6 v-if="currentUserRole !== userRoles.INFLUENCER">
                    <v-text-field
                      :hide-details="true"
                      v-model="filter.instagramHandle"
                      :height="56"
                      label="Filter by Handle"
                      outlined
                      v-on:keyup.enter="searchPosts"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    xs12
                    md3
                    sm6
                    v-if="currentUserRole !== userRoles.INFLUENCER && currentUserRole !== userRoles.CLIENT"
                  >
                    <v-select
                      :hide-details="true"
                      item-text="name"
                      item-value="id"
                      v-model="filter.clientID"
                      :items="clients"
                      :outlined="true"
                      label="Client"
                    ></v-select>
                  </v-flex>
                  <v-flex
                    xs12
                    md3
                    sm6
                    v-if="currentUserRole !== userRoles.INFLUENCER && currentUserRole !== userRoles.CLIENT"
                  >
                    <v-select
                      :hide-details="true"
                      item-text="text"
                      item-value="value"
                      v-model="filter.filterStatus"
                      :items="statuses"
                      :outlined="true"
                      label="Status"
                    ></v-select>
                  </v-flex>
                  <!-- <v-flex xs12 md2 sm6>
                    <v-checkbox color="secondary" v-model="filter.story" label="Show story types only"></v-checkbox>
                  </v-flex>-->
                  <v-flex xs12 md12 sm12>
                    <v-btn-toggle v-model="display" left mandatory :value="0" :light="true">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on">
                            <v-icon>list</v-icon>
                          </v-btn>
                        </template>
                        <span>List View</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on">
                            <v-icon>grid_on</v-icon>
                          </v-btn>
                        </template>
                        <span>Grid View</span>
                      </v-tooltip>
                    </v-btn-toggle>
                    <v-btn
                    v-if="postStatus === postStatusConfig.APPROVE"
                    @click="changePendingConfirmation"
                    :color="filter.pendingConfirmation ? 'warning' : 'default' "
                    class="ml-2 mr-2"
                    style="margin-top: -18px;"
                    small>
                      Upcoming Post Confirmation
                      <v-badge color="blue" :content="pendingCount" v-if="pendingCount"></v-badge>
                    </v-btn>
                    <v-btn
                    v-if="postStatus === postStatusConfig.APPROVE"
                    @click="changeOverdueDateFilter"
                    :color="filter.overdueLiveDate ? 'warning' : 'default' "
                    class="ml-2"
                    style="margin-top: -18px;"
                    small>
                      Overdue live date confirmation
                      <v-badge color="green" :content="overdueCount" v-if="overdueCount"></v-badge>
                    </v-btn>
                    <v-btn
                    v-if="postStatus === postStatusConfig.APPROVE"
                    @click="changeProposeDateFilter"
                    :color="filter.proposeDate ? 'warning' : 'default' "
                    class="ml-2"
                    style="margin-top: -18px;"
                    small>
                      Propose new dates
                      <v-badge color="green" :content="proposeCount" v-if="proposeCount"></v-badge>
                    </v-btn>
                    <v-btn
                    v-if="postStatus === postStatusConfig.APPROVE"
                    @click="changeEmptyLiveDateFilter"
                    :color="filter.emptyLiveDate ? 'warning' : 'default' "
                    class="ml-2"
                    style="margin-top: -18px;"
                    small>
                      Empty Live Dates
                      <v-badge color="green" :content="emptyLiveDateCount" v-if="emptyLiveDateCount"></v-badge>
                    </v-btn>
                    <v-btn
                    @click="resetFilter"
                    class="ml-2"
                    small
                    style="float: right">Reset</v-btn>
                    <v-btn
                      @click="searchPosts"
                      class="ma-0"
                      small
                      color="info"
                      style="float: right"
                    >Apply</v-btn>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
          <v-container v-if="display === 1">
            <v-row style="min-height:500px" transition="slide-x-transition">
              <v-col cols="12" sm="12" lg="3" md="4" v-for="(post, index) of posts" :key="index">
                <v-hover>
                  <!-- new card -->
                  <v-card
                    max-width="344"
                    class="mx-auto"
                    slot-scope="{ hover }"
                    :class="`elevation-${hover ? 12 : 2}`"
                  >
                    <v-list-item>
                      <!-- <v-list-item-avatar color="grey">
                        <img :src="paserImageUrl(post.author.picture)" alt="avatar" />
                      </v-list-item-avatar> -->
                      <v-list-item-content>
                        <v-list-item-title class="subtitle-1 ma-0">{{post.campaignName}}</v-list-item-title>
                        <v-list-item-subtitle class="caption font-italic">
                          By
                          <a
                            :href="'https://www.tiktok.com/@' + post.author.tiktokHandle"
                            target="_blank"
                            v-if="post.author.tiktokHandle"
                          ><img src="/static/img/tiktok-32.png" width="20px" /> @{{post.author.tiktokHandle}}</a>
                          <a
                            :href="'https://youtube.com/' + post.author.youtubeHandle"
                            target="_blank"
                            v-else-if="post.author.youtubeHandle"
                          ><v-icon>mdi-youtube</v-icon> @{{post.author.youtubeHandle}}</a>
                          <a
                            @click="openLink('https://www.xiaohongshu.com/user/profile/' + post.author.xhsHandle)"
                            v-else-if="post.author.xhsHandle"
                          >{{post.author.xhsHandle}}</a>
                          <a
                            :href="'https://www.linkedin.com/in/' + post.author.linkedinHandle"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-else-if="post.author.linkedinHandle"
                          ><v-icon color="#0A66C2" small>mdi-linkedin</v-icon> @{{post.author.linkedinHandle}}</a>
                          <a
                            :href="'https://x.com/' + (post.author.twitterHandle || post.author.instagramHandle)"
                            target="_blank"
                            rel="noopener noreferrer"
                            v-else-if="post.type === 'twitter' || post.author.twitterHandle"
                          ><img src="/static/img/x-logo.svg" width="15px" alt="" aria-hidden="true"> @{{post.author.twitterHandle || post.author.instagramHandle}}</a>
                          <a
                            :href="'https://instagram.com/' + post.author.instagramHandle"
                            target="_blank"
                            v-else
                          ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{post.author.instagramHandle}}</a>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-menu bottom right>
                          <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on">
                              <v-icon>more_vert</v-icon>
                            </v-btn>
                          </template>

                          <v-list>
                            <v-list-item
                              v-for="(menuItem, i) in menuOptions"
                              :key="i"
                              @click="actionPostBy(menuItem.action, post)"
                            >
                              <v-list-item-content>{{menuItem.name}}</v-list-item-content>
                              <v-list-item-action>
                                <v-icon>{{menuItem.icon}}</v-icon>
                              </v-list-item-action>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-list-item-action>
                    </v-list-item>

                    <v-img
                      v-if="!post.images[0]"
                      src="/static/img/upload-post-photo.png"
                      height="194px"
                      @click="viewDetailPost(post)"
                      style="cursor: pointer"
                    ></v-img>
                    <v-img
                      v-if="post.images[0] && !post.images[0].isvideo && !post.images[0].publicID"
                      :src="post.images[0].url"
                      height="194px"
                      @click="viewDetailPost(post)"
                      style="cursor: pointer"
                    ></v-img>
                    <div
                    class="post-cld-img cursor-pointer"
                    v-if="post.images[0] && !post.images[0].isvideo && post.images[0].publicID"
                    @click="viewDetailPost(post)">
                      <custom-media-v2
                        :media="campaignHelper.customPostMediaConfig(post.images[0], {})"
                      />
                    </div>
                    <video
                      v-if="post.images[0] && post.images[0].isvideo && !post.images[0].publicID"
                      height="194px"
                      width="100%"
                      @click="viewDetailPost(post)"
                      style="cursor: pointer"
                    >
                      <source :src="post.images[0].url" type="video/mp4" />Your browser does not support the video tag.
                    </video>
                    <div style="max-height: 200px;overflow: hidden;" v-if="post.images[0] && post.images[0].isvideo && post.images[0].publicID" @click="viewDetailPost(post)">
                      <custom-media-v2
                        :media="campaignHelper.customPostMediaConfig(post.images[0], { videoPreview: true })"
                      />
                    </div>
                    <v-card-text>
                      <div v-if="post.type !== 'post/carousel' && post.vdoLink " style="margin-top:10px;">
                        <v-btn
                          class="ma-0"
                          style="margin-top:5px !important;"
                          outlined
                          color="indigo"
                          target="_blank"
                          :href="post.vdoLink"
                          small
                        >
                          <v-icon left>mdi-link</v-icon>
                          Video Link
                        </v-btn>
                      </div>
                    </v-card-text>

                    <v-card-actions>
                      <v-row>
                        <v-col>
                          <v-chip
                            v-for="label in post.labels"
                            :key="label.text"
                            class="ma-1"
                            small
                            :color="label.color"
                            :outlined="label.outlined"
                            :dark="label.dark"
                            @click="exec(label.action, post)"
                          >
                            <span v-if="label.faIcon">
                              <i :class="label.faIcon"></i>&nbsp;&nbsp;
                            </span>
                            {{label.text}}
                            <v-icon v-if="label.icon" right>{{label.icon}}</v-icon>
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                  <!-- new card -->
                </v-hover>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-pagination
                  v-model="page"
                  circle
                  @input="pageChanged()"
                  :value="pagging.page"
                  :length="paginationLength"
                ></v-pagination>
              </v-col>
            </v-row>
          </v-container>
          <!-- display as list -->
          <v-layout row wrap v-if="display === 0">
            <v-flex md12 xs12 sm12>
              <v-toolbar flat color="white">
                <!-- <v-toolbar-title>Expandable Table</v-toolbar-title> -->
                <v-spacer></v-spacer>
                <v-menu offset-x v-if="selected.length > 0">
                  <template v-slot:activator="{ on }">
                    <v-btn color="secondary" v-on="on">Bulk Action</v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(menuItem, i) in tableActions"
                      :key="i"
                      @click="performSelected(menuItem.action)"
                    >
                      <v-list-item-content>{{menuItem.name}}</v-list-item-content>
                      <!-- <v-list-tile-action>
                        <v-icon>{{menuItem.icon}}</v-icon>
                      </v-list-tile-action>-->
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-toolbar>
              <v-data-table
                item-key="_id"
                v-model="selected"
                :show-select="true"
                :server-items-length="totalItems"
                :options.sync="pagging"
                :headers="headers"
                :items="posts"
                :footer-props="{
                  itemsPerPageOptions: rowsPerPage
                }"
                class="elevation-1"
              >
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item._id">
                      <td>
                        <v-checkbox
                          class="pa-0 ma-0"
                          v-model="selected"
                          :checked="false"
                          :value="item"
                          primary
                          hide-details
                        ></v-checkbox>
                      </td>

                      <td class="text-xs-left">{{ item.campaignName }}</td>
                      <td class="text-xs-justify pa-1">
                        <a
                            :href="'https://www.tiktok.com/@' + item.author.tiktokHandle"
                            target="_blank"
                            v-if="item.author.tiktokHandle"
                          ><img src="/static/img/tiktok-32.png" width="20px" /> @{{item.author.tiktokHandle}}</a>
                        <a
                          :href="'https://youtube.com/' + item.author.youtubeHandle"
                          target="_blank"
                          v-else-if="item.author.youtubeHandle"
                        ><v-icon>mdi-youtube</v-icon> @{{item.author.youtubeHandle}}</a>
                        <a
                          :href="'https://www.linkedin.com/in/' + item.author.linkedinHandle"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-else-if="item.author.linkedinHandle"
                        ><v-icon color="#0A66C2" small>mdi-linkedin</v-icon> @{{item.author.linkedinHandle}}</a>
                        <a
                          :href="'https://x.com/' + (item.author.twitterHandle || item.author.instagramHandle)"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-else-if="item.type === 'twitter' || item.author.twitterHandle"
                        ><img src="/static/img/x-logo.svg" width="15px" alt="" aria-hidden="true"> @{{item.author.twitterHandle || item.author.instagramHandle}}</a>
                        <a
                          :href="'https://instagram.com/' + item.author.instagramHandle"
                          target="_blank"
                          v-else
                        ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{item.author.instagramHandle}}</a>
                      </td>
                      <td class="text-xs-left">
                        <div v-for="label in item.labels" :key="label.text">
                          <v-chip
                            class="ma-1"
                            small
                            :color="label.color"
                            :outlined="label.outlined"
                            :dark="label.dark"
                            @click="exec(label.action, item)"
                            v-if="!label.postType"
                          >
                            {{label.text}}
                            <v-icon right>{{label.icon}}</v-icon>
                          </v-chip>
                        </div>
                        <div v-if="postStatus === postStatusConfig.LIVE && item.postURL">
                          <!-- Show scheduled date information -->
                          <v-btn rounded small color="secondary" :href="item.postURL" target="_blink">
                            View Live Post
                            <v-icon right>link</v-icon>
                          </v-btn>
                        </div>
                      </td>
                      <td class="text-xs-left">
                        <div v-for="label in item.labels" :key="label.text">
                          <v-chip
                            class="ma-1"
                            small
                            :color="label.color"
                            :outlined="label.outlined"
                            :dark="label.dark"
                            @click="exec(label.action, item)"
                            v-if="label.postType"
                          >
                            <span v-if="label.faIcon">
                              <i :class="label.faIcon"></i>&nbsp;&nbsp;
                            </span>
                            {{label.text}}
                            <v-icon v-if="label.icon" right>{{label.icon}}</v-icon>
                          </v-chip>
                        </div>
                      </td>
                      <td class="text-xs-left">{{ formatDate(item.createdAt, 'LLL')}}</td>
                      <td class="text-xs-left">
                        <v-menu bottom left>
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on">Action</v-btn>
                          </template>

                          <v-list>
                            <v-list-item
                              v-for="(menuItem, i) in menuOptions"
                              :key="i"
                              @click="actionPostBy(menuItem.action, item)"
                            >
                              <v-list-item-content>{{menuItem.name}}</v-list-item-content>
                              <v-list-item-action>
                                <v-icon>{{menuItem.icon}}</v-icon>
                              </v-list-item-action>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-layout>
    </section>
    <view-post-modal
      v-model="viewPostDialog"
      :post="viewPostData"
      :csActions="showCsEditAction"
      :proposeDateActions="showProposeDateAction"
      :saleActions="showSaleAction"
      :clientActions="showClientEditAction"
      :influencerActions="showInfluencerEditAction"
      :cs_inf_chatbox="show_cs_inf_chatbox"
      :client_inf_chatbox="show_client_inf_chatbox"
      :postAbuseHistory="showPostAbuseHistory"
      :postReviewApproved="showPostReviewApproved"
      :postHistory="showPostHistory"
      :userObj="user"
      :value="viewPostDialog"
      @csApproved="csApproveFromView"
      @saleReleased="saleReleasePost"
      @directReleased="directReleasePost"
      @editPost="editPostFromView"
      @editLiveDate="editLiveDateFromView"
      @mainPostChanged="reloadPostView"
      @postUpdated="getPosts()"
    />
    <edit-post-modal
      v-model="editPostDialog"
      :post="editPostData"
      :postAbuseHistory="true"
      @postUpdated="getPosts()"
      :value="editPostDialog"
      :userObj="user"
    />
    <assign-campaign-modal
      v-model="assignCampaignDialog"
      :post="assignCampaignPostData"
      @success="assignedCampaign($event)"
    />
    <assign-campaign-multiple-modal
      v-model="assignCampaignMultipleDialog"
      :posts="assignCampaignPosts"
      @success="assignedCampaign($event)"
    />
    <map-influencer-modal
      v-model="mapInfluencerDialog"
      :post="mapInfluencerPostData"
      @successInfluencerMap="influencerMapSuccess($event)"
    />
    <map-influencer-multiple-modal
      v-model="mapInfluencerMultipleDialog"
      :posts="mapInfluencerPosts"
      @successInfluencerMap="influencerMapSuccess($event)"
    />
    <submission-review-multiple-modal
      v-model="submissionReviewMultipleDialog"
      :posts="selected"
      :internalApprove="true"
      @successBulkApprove="getPosts()"
    />
    <add-post-to-campaign
      v-model="addPostToCampaign"
      :value="addPostToCampaign"
      :campaign="campaignDataForAddPost"
      :postID="postIdToUpdate"
      :post="addPost"
      @done="postAdded"
    ></add-post-to-campaign>
    <change-post-status-modal
      v-model="changeStatusDialog"
      :post="postDataForChangeStatus"
      :postIds="changePostIds"
      @updated="getPosts()"
    />
    <edit-live-date-modal 
      v-model="editLiveDateDialog"
      :post="postDataForEditLiveDate"
      @postUpdated="searchPosts()"
    />
    <v-dialog v-model="loading" hide-overlay persistent width="250">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import config from '@/config';
import ViewPostModal from './ViewPostModal.vue';
import EditPostModal from './EditPost.vue';
import EditLiveDateModal from './EditLiveDateModal.vue';
import AssignCampaignModal from './AssignCampaignModal.vue';
import MapInfluencerModal from './MapInfluencerModal.vue';
import AssignCampaignMultipleModal from './AssignCampaignMultipleModal.vue';
import SubmissionReviewMultipleModal from './SubmissionReviewMultiple.vue';
import MapInfluencerMultipleModal from './MapInfluencerMultipleModal.vue';
import postConfig from './postConfig';
import PostAPI from './postApi';
import ClientAPI from '../Client/clientAPIs';
import paymentAPIs from '../Influencer/paymentAPIs';
import CampaignAPIs from '../Campaign/campaignAPIs';
import AddPostToCampaign from '../../scoped/campaign/AddPostToCampaign';
import ChangePostStatusModal from './ChangePostStatusModal';
import campaignHelper from '../Campaign/campaignHelper';
import CustomMediaV2 from '../../scoped/custom/CustomMediaV2';
import Utils from '../../../utils';
import moment from 'moment';
import { platformDisplayName } from '@/utils/platformDisplay';

export default {
  components: {
    ViewPostModal,
    AddPostToCampaign,
    ChangePostStatusModal,
    AssignCampaignModal,
    MapInfluencerModal,
    AssignCampaignMultipleModal,
    MapInfluencerMultipleModal,
    SubmissionReviewMultipleModal,
    EditPostModal,
    EditLiveDateModal,
    CustomMediaV2
  },
  data() {
    return {
      posts: [],
      groupedPosts: [],
      rating: 3,
      viewPostData: {},
      postDataForEditLiveDate: {},
      filter: {
        instagramHandle: null,
        campaignName: null,
        campaignId: null,
        postID: null,
        influencerID: null,
        clientID: null,
        today: false,
        story: false,
        dateConfirmed: null,
        filterStatus: ''
      },
      pagging: {
        page: 1,
        itemsPerPage: 6
      },
      postFilter: null,
      showPostLayout: false,
      totalItems: 0,
      instagramHandleList: [],
      clients: [],
      rowsPerPage: [6, 12, 18, 26, { text: 'All', value: -1 }],
      editPostData: {},
      assignCampaignPostData: {},
      mapInfluencerPostData: {},
      assignCampaignPosts: [],
      mapInfluencerPosts: [],
      viewPostDialog: false,
      editPostDialog: false,
      editLiveDateDialog: false,
      assignCampaignDialog: false,
      mapInfluencerDialog: false,
      assignCampaignMultipleDialog: false,
      mapInfluencerMultipleDialog: false,
      submissionReviewMultipleDialog: false,
      showCsEditAction: false,
      showProposeDateAction: false,
      showSaleAction: false,
      showClientEditAction: false,
      showInfluencerEditAction: false,
      show_cs_inf_chatbox: false,
      show_client_inf_chatbox: false,
      showPostAbuseHistory: false,
      showPostReviewApproved: false,
      showPostHistory: false,
      defaultPoster: {
        instagramHandle: '-------',
        picture: '/static/img/kobe_bg_main.png'
      },
      menuOptions: [],
      tableActions: [],
      selected: [],
      changePostIds: [],
      display: '',
      isFirstLoad: true,
      headers: [
        { text: 'Campaign', value: 'campaignName', sortable: true },
        { text: 'Influencer', value: 'submittedBy', sortable: true },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Format', value: 'format', sortable: false },
        { text: 'Submitted At', value: 'createdAt', sortable: true },
        { text: 'Actions', sortable: false }
      ],
      showConnectionError: false,
      loading: false,
      page: 1,
      addPostToCampaign: false,
      campaignDataForAddPost: null,
      postIdToUpdate: null,
      changeStatusDialog: false,
      postDataForChangeStatus: null,
      campaignHelper,
      pendingCount: 0,
      confirmedCount: 0,
      overdueCount: 0,
      proposeCount: 0,
      emptyLiveDateCount: 0,
      allPosts: false,
      campaignList: [],
      showDetailModalFromRoute: false
    };
  },
  watch: {
    posts: function(newPosts) {
      var tmpArr = [];
      newPosts.forEach(post => {
        tmpArr.push(post.author.instagramHandle);
      });
      this.instagramHandleList = Array.from(new Set(tmpArr));
    },
    postStatus: function() {
      this.pagging.page = 1
      this.page = 1
      this.filter.postID = null
      this.getPosts();
    },
    pagging: function(previous, after) {
      // This comparison is required the order in 2 obj is same
      if (JSON.stringify(previous) !== JSON.stringify(after) && (this.postStatus === -1 && this.filter.campaignId)) {
        this.getPosts();
      }
    },
    selected: function() {
      this.validateTableActions(this.selected);
    },
    $route: function() {
      this.pagging.page = 1
      this.filter.filterStatus = ''
      this.filter.postID = null
      this.viewPostByRouter();
    }
    // filterCampaignID: function(value) {
    //   if (value) {
    //     this.filter.campaignId = value
    //     this.getPosts()
    //   }
    // }
  },
  methods: {
    openViewPostLayout(campaignName, campaignId, instagramHandle, instagramId) {
      this.showPostLayout = true;
      let postFilter = {};
      if (campaignName) {
        postFilter.campaignName = campaignName;
      }
      if (campaignId) {
        postFilter.campaignId = campaignId;
      }
      if (instagramHandle) {
        postFilter.instagramHandle = instagramHandle;
      }
      if (instagramId) {
        postFilter.instagramId = instagramId;
      }
      this.postFilter = Object.assign({}, postFilter);
      this.getPosts();
    },
    closeViewPostLayout() {
      this.showPostLayout = false;
      this.posts = [];
      // Reset the filter to avoid the wrong parameters in the furture
      this.postFilter = null;
    },
    changePostStatus(post) {
      this.postDataForChangeStatus = post;
      this.changePostIds = []
      this.changeStatusDialog = true;
    },
    changeBulkPostStatus(ids) {
      this.changePostIds = ids
      this.postDataForChangeStatus = this.posts[0]
      this.changeStatusDialog = true;
    },
    archivePost(ids) {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to archive?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          let data = ids.map(postID => {
            return Object.assign({}, {
              id: postID,
              archive: true
            })
          })
          // Submit request to save archived post data
          await this.$store.dispatch('post/updatePostByIds', data)
          this.isLoading = false;
          if (!this.postUpdateStatus) {
            this.$swal({
              text: 'Error Archiving Posts.',
              type: 'error'
            });
            return
          }
          // Show success message
          this.$swal({
            text: 'Successfully Archived.',
            type: 'success'
          });
          this.getPosts();
        }
      })
    },
    restoreArchive(ids) {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to restore?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          let data = ids.map(postID => {
            return Object.assign({}, {
              id: postID,
              archive: false
            })
          })
          // Submit request to restore archived post data
          await this.$store.dispatch('post/updatePostByIds', data)
          this.isLoading = false;
          if (!this.postUpdateStatus) {
            this.$swal({
              text: 'Error Restoring Posts.',
              type: 'error'
            });
            return
          }
          // Show success message
          this.$swal({
            text: 'Successfully restored.',
            type: 'success'
          });
          this.getPosts();
        }
      })
    },
    postAdded() {
      this.addPostToCampaign = false;
      this.$swal({
        type: 'success',
        title: 'Post URL is added, You can now see in Campaign Report'
      });
      this.getPosts();
    },
    bulkApprove() {
      if (this.selected.length > 0) {
        this.submissionReviewMultipleDialog = true;
      }
    },
    resetFilter() {
      let campaignId = this.filter.campaignId
      this.filter = {
        instagramHandle: null,
        campaignName: null,
        clientID: null,
        campaignId,
        today: false,
        story: false
      };
      this.getPosts();
    },
    assignedCampaign() {
      this.getPosts();
    },
    influencerMapSuccess() {
      this.getPosts();
    },
    validateTableActions(selected) {
      let disableApproveBtn = false;
      let disableReleaseBtn = false;
      if (!selected || selected.length === 0) {
        this.tableActions = this.tableActions.map(item => {
          item.disabled = true;
          return item;
        });
        return;
      }
      let disableAcceptBtn = false;
      for (let item of selected) {
        if (!item.campaignID || !item.postDate || item.waiting_release || item.status !== this.postStatusConfig.AD_STRATEGIST_PENDING) {
          disableApproveBtn = true;
        }
        if (!item.waiting_release) {
          disableReleaseBtn = true;
        }
        if (item.status !== this.postStatusConfig.CLIENT_PENDING) {
          disableAcceptBtn = true;
        }
      }
      for (let act of this.tableActions) {
        if (act.action === 'csApprove') {
          act.disabled = disableApproveBtn;
        } else if (act.action === 'saleApprove') {
          act.disabled = disableReleaseBtn;
        } else if (act.action === 'clientApprove') {
          act.disabled = disableAcceptBtn;
        }
      }
      if (this.postStatus === this.postStatusConfig.ARCHIVE) {
        this.tableActions = this.tableActions.filter(act => act.action === 'restore')
      } else {
        this.tableActions = this.tableActions.filter(act => act.action !== 'restore')
      }
    },
    performSelected(action) {
      let ids = this.selected.map(item => item._id);
      switch (action) {
        case 'saleApprove':
          this.releasePosts(ids);
          break;
        case 'directRelease':
          this.releasePosts(ids);
          break;
        case 'csApprove':
          this.approvePosts(ids);
          break;
        case 'clientApprove':
          this.bulkApprove();
          break;
        case 'deletePost':
          this.deletePosts(ids);
          break;
        case 'changeStatus':
          this.changeBulkPostStatus(ids);
          break;
        case 'archivePost':
          this.archivePost(ids)
          break;
        case 'markAsMetadataTagged':
          this.markMetadataTag(ids);
          break;
        case 'markAsAbuseResolved':
          this.abuseResolvePosts(ids);
          break;
        case 'releaseAbuseResolved':
          this.releaseAbuseResolvedPosts(ids);
          break;
        case 'restore':
          this.restoreArchive(ids)
          break;
        case 'assignCampaign':
          this.assignCampaignToPostMultiple(ids);
          break;
        case 'mapInfluencer':
          this.mapInfluencerToPostMultiple(ids);
          break;
      }
    },
    pageChanged() {
      this.pagging.page = this.page;
      this.getPosts();
    },
    isIncludeInAbuseReport(reportedDraftId, clientReportArr) {
      if (!clientReportArr) return [];
      let tmpArr = clientReportArr.map(item => item.draftPostId);
      return tmpArr.includes(reportedDraftId);
    },
    buttonShow(type) {
      const buttonPermission = config['userPermissions']['post'][type];
      if (Array.isArray(buttonPermission)) {
        return buttonPermission.includes(this.currentUserRole);
      } else if (typeof buttonPermission === 'object') {
        return buttonPermission.userRoles.includes(this.currentUserRole) && buttonPermission.postStatus.includes(this.postStatus);
      }
    },
    filterMenuOptions() {
      let options = postConfig.menuActions;
      if (this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH) {
        this.menuOptions = options;
      } else if (this.postStatus === -1) {
        if (this.currentUserRole !== this.userRoles.CLIENT && this.currentUserRole !== this.userRoles.INFLUENCER) {
          this.menuOptions = options;
        }
      } else {
        this.menuOptions = options.filter(option => this.buttonShow(option.action));
      }
    },
    filterTableActions() {
      let options = postConfig.tableActions;
      if (this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH) {
        this.tableActions = options;
      } else {
        this.tableActions = options.filter(option => this.buttonShow(option.action));
      }
      this.tableActions = this.tableActions.map(item => {
        item.disabled = true;
        return item;
      });
    },
    actionPostBy(action, post) {
      switch (action) {
        case 'view':
          this.viewDetailPost(post);
          break;
        case 'edit':
          this.editPost(post);
          break;
        case 'editLiveDate':
          this.editLiveDate(post);
          break;
        case 'assignCampaign':
          this.assignCampaignToPost(post);
          break;
        case 'mapInfluencer':
          this.mapInfluencerToPost(post);
          break;
        case 'csApprove':
          this.csApprovePost(post);
          break;
        case 'saleApprove':
          this.saleReleasePost(post);
          break;
        case 'directRelease':
          this.directReleasePost(post);
          break;
        case 'clientReview':
          this.startSubmissionReview(post);
          break;
        case 'enterPostURL':
          this.enterPostURL(post);
          break;
        case 'markAsMetadataTagged':
          this.markMetadataTag([post._id]);
          break;
        case 'markAsComplete':
          this.completePost(post);
          break;
        case 'markAsAbuseResolved':
          this.abuseResolvePosts([post._id]);
          break;
        case 'releaseAbuseResolved':
          this.releaseAbuseResolvedPosts([post._id]);
          break;
        case 'submitPostPayout':
          this.submitPostPayout(post);
          break;
        case 'changePostStatus':
          this.changePostStatus(post);
      }
    },
    // should be paginate posts (8 posts max at per page) to improve performance
    getPosts() {
      let status = this.postStatus;
      this.loading = true;
      let query = Utils.func.clean(this.filter);
      query.page = this.pagging.page;
      query.perPage = this.pagging.itemsPerPage;
      query.status = status;
      query.sortBy = this.pagging.sortBy && this.pagging.sortBy.length > 0 ? this.pagging.sortBy[0] : null
      query.descending = this.pagging.sortDesc && this.pagging.sortDesc.length > 0 ? this.pagging.sortDesc[0] : null
      PostAPI.getPost(query)
        .then(resp => {
          this.posts = [];
          this.selected = []; // Avoiding auto selection from data-table, this might be a bug from vuetify
          this.loading = false;
          this.showConnectionError = false;
          let posts = resp.posts;
          let totalItems = resp.totalItems;
          this.totalItems = totalItems;
          this.pendingCount = resp.pendingCount;
          this.overdueCount = resp.overdueLiveDateCount;
          this.proposeCount = resp.proposeDateCount;
          this.emptyLiveDateCount = resp.emptyLiveDateCount;
          posts = posts.map(post => {
            // post.tags = Utils.func.extractHashTagsFromString(post.captionText);
            post.labels = this.getPostLabels(post);
            post.author = post.mapInfluencer || post.submitedBy || this.defaultPoster;
            return post;
          });
          setTimeout(() => {
            this.posts = posts;
          }, 0)
          // open post for confirm date dialog
          if (this.$route.query.postID && !this.showDetailModalFromRoute) {
            this.showDetailModalFromRoute = true
            let matchPost = posts.find(p => p._id === this.$route.query.postID)
            if (matchPost) {
              this.viewDetailPost(matchPost)
            }
          }
        })
        .catch(err => {
          this.showConnectionError = true;
          this.loading = false;
          console.error(err);
        });
      this.filterTableActions();
      this.filterMenuOptions();
    },
    getClients() {
      ClientAPI.getAllClients().then(resp => {
        let clients = Object.assign([], resp.data);
        clients.sort((a, b) => {
          if (a.name > b.name) {
            return 1;
          }
          if (b.name > a.name) {
            return -1;
          }
          return 0;
        });
        this.clients = [{ name: 'All', id: null }, ...clients];
      });
    },
    searchPosts() {
      this.pagging.page = 1
      this.page = 1
      this.getPosts()
    },
    reloadPostView(postData) {
      this.viewDetailPost(postData);
      this.searchPosts()
    },
    viewDetailPost(post) {
      if (post.status < config.postStatus.APPROVE && this.currentUserRole === config.userRoles.AD_STRATEGIST && (!post.waiting_release || post.additional_abuse_reported)) {
        this.showCsEditAction = true;
      } else {
        this.showCsEditAction = false;
      }
      if ((post.status === config.postStatus.CLIENT_PENDING || post.status === config.postStatus.APPROVE) &&
      (this.currentUserRole === config.userRoles.AD_STRATEGIST || this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH)) {
        this.showProposeDateAction = true;
      } else {
        this.showProposeDateAction = false;
      }
      if (post.status < config.postStatus.APPROVE && this.currentUserRole === config.userRoles.ACCOUNT_MANAGER) {
        this.showSaleAction = true;
      } else {
        this.showSaleAction = false;
      }
      if (post.status === config.postStatus.CLIENT_PENDING && this.currentUserRole === config.userRoles.CLIENT) {
        this.showClientEditAction = true;
      } else {
        this.showClientEditAction = false;
      }
      if (post.status < config.postStatus.APPROVE && this.currentUserRole === config.userRoles.INFLUENCER) {
        this.showInfluencerEditAction = true;
      } else {
        this.showInfluencerEditAction = false;
      }
      if ((this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === config.userRoles.AD_STRATEGIST || this.currentUserRole === config.userRoles.INFLUENCER) &&
        post.campaignID
      ) {
        this.show_cs_inf_chatbox = true;
      } else {
        this.show_cs_inf_chatbox = false;
      }
      if ((this.currentUserRole === this.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === config.userRoles.AD_STRATEGIST) &&
      post.campaignID) {
        this.show_client_inf_chatbox = true
      } else {
        this.show_client_inf_chatbox = false
      }
      if (post.clientReportAbuse) {
        this.showPostAbuseHistory = true;
      } else {
        this.showPostAbuseHistory = false;
      }
      if (post.status === config.postStatus.APPROVE || post.status === config.postStatus.LIVE && this.currentUserRole !== config.userRoles.INFLUENCER) {
        this.showPostReviewApproved = true;
      } else {
        this.showPostReviewApproved = false;
      }
      if (post.status < config.postStatus.APPROVE) {
        this.showPostHistory = true;
      } else {
        this.showPostHistory = false;
      }
      this.fetchPost(post._id);
      this.$store.dispatch('post/updatePostViewUser', { postID: post._id })
      this.viewPostDialog = true;
      // this.getPosts();
    },
    editPostFromView: function(post) {
      this.editPost(post);
    },
    editLiveDateFromView: function(post) {
      this.editLiveDate(post)
    },
    exec(action, item) {
      var fn = this[action];
      if (typeof fn === 'function') fn(item);
    },
    getPostLabels(post) {
      let labels = [];
      if (this.postStatus === this.postStatusConfig.AD_STRATEGIST_PENDING &&
      (this.currentUserRole <= this.userRoles.AD_STRATEGIST || this.currentUserRole === this.userRoles.ACCOUNT_MANAGER)) {
        if (!post.campaignID) {
          labels.push({
            text: 'Campaign not assigned',
            icon: 'warning',
            outlined: true,
            dark: false,
            color: 'red',
            action: 'assignCampaignToPost'
          });
        }
        if (post.waiting_release && !post.abuse_resolved) {
          labels.push({
            text: 'Pending to release',
            icon: 'nights_stay',
            outlined: true,
            dark: false,
            color: 'blue',
            action: 'viewDetailPost'
          });
        }
      }
      if ((this.currentUserRole <= this.userRoles.AD_STRATEGIST || this.currentUserRole === this.userRoles.ACCOUNT_MANAGER) &&
      !post.postDate &&
      !post.postDateEnd &&
      this.postStatus >= this.postStatusConfig.APPROVE) {
        labels.push({
          text: 'Empty Live Date',
          icon: 'warning',
          outlined: true,
          dark: false,
          color: 'red',
          action: 'editLiveDate'
        });
      }
      if ((this.currentUserRole <= this.userRoles.AD_STRATEGIST ||
      this.currentUserRole === this.userRoles.ACCOUNT_MANAGER) && post.abuse_resolved) {
        labels.push({
          text: 'Pending to release',
          icon: 'nights_stay',
          outlined: true,
          dark: false,
          color: 'blue',
          action: 'viewDetailPost'
        });
      }
      if (this.postStatus === this.postStatusConfig.APPROVE && (this.currentUserRole <= this.userRoles.AD_STRATEGIST ||
      this.currentUserRole === this.userRoles.ACCOUNT_MANAGER) && post.requestDate && !post.propose_dates) {
        labels.push({
          text: 'Live Date Change Requested',
          icon: 'warning',
          outlined: true,
          dark: false,
          color: 'secondary',
          action: 'viewDetailPost'
        });
      }
      if (this.postStatus === this.postStatusConfig.APPROVE && (this.currentUserRole <= this.userRoles.AD_STRATEGIST ||
      this.currentUserRole === this.userRoles.ACCOUNT_MANAGER) && !post.dateConfirmed) {
        labels.push({
          text: 'Pending Confirmation',
          icon: 'schedule',
          outlined: true,
          dark: false,
          color: 'blue',
          action: 'viewDetailPost'
        });
      }
      if (this.postStatus === this.postStatusConfig.APPROVE && (this.currentUserRole <= this.userRoles.AD_STRATEGIST ||
      this.currentUserRole === this.userRoles.ACCOUNT_MANAGER) && post.dateConfirmed) {
        labels.push({
          text: 'Confirmed Post Date',
          icon: 'check',
          outlined: true,
          dark: false,
          color: 'green',
          action: 'viewDetailPost'
        });
      }
      if ((this.currentUserRole <= this.userRoles.AD_STRATEGIST || this.currentUserRole === this.userRoles.ACCOUNT_MANAGER) && post.propose_dates) {
        labels.push({
          text: 'Propose Date Submitted',
          icon: 'check',
          outlined: true,
          dark: false,
          color: 'blue',
          action: 'viewDetailPost'
        });
      }
      if (
        !post.waiting_release &&
        this.postStatus === this.postStatusConfig.AD_STRATEGIST_PENDING &&
        (this.currentUserRole <= this.userRoles.COMPANY_ADMIN_LOW || this.currentUserRole === this.userRoles.ACCOUNT_MANAGER)
      ) {
        labels.push({
          text: 'Work in progress by CC',
          icon: 'nights_stay',
          outlined: true,
          dark: false,
          color: 'red',
          action: 'viewDetailPost'
        });
      }
      if (this.postStatus === this.postStatusConfig.CLIENT_PENDING &&
      this.currentUserRole !== this.userRoles.INFLUENCER && !post.abuse_resolved && post.release_abuse_resolved) {
        labels.push({
          text: 'Abuse Resolved',
          icon: 'check',
          color: 'green',
          action: 'viewDetailPost'
        });
      }

      if (this.postStatus === this.postStatusConfig.CLIENT_PENDING &&
      this.currentUserRole !== this.userRoles.INFLUENCER &&
      !post.abuse_resolved &&
      !post.release_abuse_resolved) {
        if (this.isIncludeInAbuseReport(post.draftId, post.clientReportAbuse)) {
          if (post.additional_abuse_reported) {
            labels.push({
              text: 'Additional Abuse Reported',
              icon: 'warning',
              outlined: true,
              dark: false,
              color: 'deep-orange',
              action: 'viewDetailPost'
            });
          } else {
            labels.push({
              text: 'Abuse Reported',
              icon: 'warning',
              outlined: true,
              dark: false,
              color: 'deep-orange',
              action: 'viewDetailPost'
            });
          }
        } else {
          if (post.viewUsers && post.viewUsers.includes(this.currentUserID)) {
            labels.push({
              text: 'Viewed',
              outlined: true,
              dark: false,
              icon: 'remove_red_eye',
              color: 'grey',
              action: 'viewDetailPost'
            });
          } else {
            labels.push({
              text: 'New',
              outlined: true,
              dark: false,
              icon: 'new_releases',
              color: 'green',
              action: 'viewDetailPost'
            });
          }
        }
      }

      if (
        post.comments &&
        this.postStatus < this.postStatusConfig.APPROVE &&
        (this.currentUserRole === this.userRoles.INFLUENCER ||
        this.currentUserRole === this.userRoles.AD_STRATEGIST ||
        this.currentUserRole === this.userRoles.ACCOUNT_MANAGER)
      ) {
        labels.push({
          text: `(${this.commentsInfo(post.comments)}) Comments`,
          icon: 'comment',
          outlined: true,
          dark: false,
          color: 'primary',
          action: 'viewDetailPost'
        });
      }

      // if (this.postStatus === this.postStatusConfig.APPROVE && !post.postURL &&
      // (this.currentUserRole <= this.userRoles.AD_STRATEGIST || this.currentUserRole === this.userRoles.ACCOUNT_MANAGER) && post.requestDate) {
      //   if (this.checkAfter(post.requestDate)) {
      //     labels.push({
      //       text: 'Overdue Request Date',
      //       icon: 'schedule',
      //       outlined: true,
      //       dark: false,
      //       color: 'red',
      //       action: 'viewDetailPost'
      //     });
      //   }
      // }

      if (this.postStatus === this.postStatusConfig.APPROVE && !post.postURL && post.postDate) {
        if (this.checkAfter(post.postDate)) {
          labels.push({
            text: `${this.formatDate(post.postDate)}`,
            icon: 'schedule',
            outlined: true,
            dark: false,
            color: 'red',
            action: 'viewDetailPost'
          });
        } else if (this.checkSame(post.postDate)) {
          labels.push({
            text: `Today - ${this.formatDate(post.postDate)}`,
            icon: 'schedule',
            outlined: false,
            dark: true,
            color: 'green',
            action: 'viewDetailPost'
          });
        } else {
          labels.push({
            text: this.formatDate(post.postDate),
            icon: 'schedule',
            outlined: true,
            dark: false,
            color: 'green',
            action: 'viewDetailPost'
          });
        }
      }

      if (post.postURL) {
        labels.push({
          text: 'Post URL Added',
          icon: 'check',
          color: 'green',
          action: 'viewDetailPost'
        });
      }
      if (post.hasReport) {
        labels.push({
          text: 'Present in Campaign Report',
          icon: 'check',
          color: 'primary',
          action: 'viewDetailPost'
        });
      }

      if (post.metadataTagged) {
        labels.push({
          text: 'Metadata Tagged',
          faIcon: 'fa fa-tag',
          color: 'blue',
          outlined: true,
          action: 'viewDetailPost'
        });
      }

      if (this.currentUserRole === this.userRoles.INFLUENCER && this.postStatus === this.postStatusConfig.APPROVE) {
        labels.push({
          text: 'Submit Payout',
          icon: 'assignment_turned_in',
          color: 'primary',
          action: 'submitPostPayout'
        });
      }

      if (post.type) {
        labels.push({
          text: platformDisplayName(post.type),
          color: 'primary',
          postType: true,
          action: 'viewDetailPost'
        })
      }

      return labels;
    },
    editPost(post) {
      this.fetchPostAsync(post._id).then((newPost) => {
        post.reportAbuse = newPost.reportAbuse
        this.editPostData = post;
        this.editPostDialog = true;
      });
    },
    editLiveDate(post) {
      this.postDataForEditLiveDate = post
      this.editLiveDateDialog = true
    },
    assignCampaignToPost(post) {
      this.assignCampaignPostData = post;
      this.assignCampaignDialog = true;
    },
    mapInfluencerToPost(post) {
      this.mapInfluencerPostData = post;
      this.mapInfluencerDialog = true;
    },
    assignCampaignToPostMultiple(postIds) {
      let selectedPost = this.selected.filter(s => postIds.includes(s._id))
      this.assignCampaignPosts = selectedPost;
      this.assignCampaignMultipleDialog = true;
    },
    mapInfluencerToPostMultiple(postIds) {
      let selectedPost = this.selected.filter(s => postIds.includes(s._id))
      this.mapInfluencerPosts = selectedPost;
      this.mapInfluencerMultipleDialog = true;
    },
    paserImageUrl(url) {
      if (url) {
        var newUrl = url
          .replace('http://imgp.socapi.icu/', location.origin + '/socapi')
          .replace('https://imgp.socapi.icu/', location.origin + '/socapi');
        return newUrl;
      } else {
        return '/static/img/avatar/user.png';
      }
    },
    paserAudienceImageUrl(audience) {
      if (audience.user_profile !== undefined) {
        var newUrl = audience.user_profile.picture;
        return newUrl;
      } else {
        return '/static/img/avatar/user.png';
      }
    },
    csApproveFromView: function(post) {
      this.csApprovePost(post);
    },
    csApprovePost(post) {
      if (!post.campaignID) {
        this.$swal({
          title: 'Please select the campaign for this post',
          type: 'warning'
        });
      } else if (post.waiting_release) {
        this.$swal({
          title: 'Already Submitted',
          text: 'You have already approved this draft.\nIt is now pending to release from AM.',
          type: 'info'
        });
      } else {
        let id = post._id;
        this.approvePosts([id]);
      }
    },
    approvePosts(postIds) {
      this.$swal({
        title: 'Are you sure?',
        text: 'Upon confirmation, the post will be sent to AM for approval',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Agree',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return PostAPI.approvePost(postIds)
            .then(data => {
              return data;
            })
            .catch(error => {
              console.error(error);
              this.$swal({
                title: 'Error in approving Post, please try again',
                type: 'error'
              });
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Show success message
          this.$swal({
            title: 'Success',
            text: 'The draft is now waiting for release from AM.\nOnced released, it will sent to client.',
            type: 'success'
          });
          // Reload Page
          // this.$router.push({ path: '/posts/pending-kobe' });
          this.$emit('input');
          this.getPosts();
          this.viewPostDialog = false;
        } else {
          // Do nothing for now
        }
      });
    },
    abuseResolvePosts(postIds) {
      this.$swal({
        title: 'Are you sure?',
        text: 'Upon Confirmation, the latest edited version will be send to AM as abuse resolved.',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Agree',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return PostAPI.abuseResolvePost(postIds)
            .then(data => {
              return data;
            })
            .catch(error => {
              console.error(error);
              this.$swal({
                title: 'Error in abuse resolving Post, please try again',
                type: 'error'
              });
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Show success message
          this.$swal({
            title: 'Success',
            text: 'The abuse resolved draft is now waiting for release from AM.\nOnced released, it will sent to client.',
            type: 'success'
          });
          // Reload Page
          // this.$router.push({ path: '/posts/pending-kobe' });
          this.$emit('input');
          this.getPosts();
          this.viewPostDialog = false;
        } else {
          // Do nothing for now
        }
      });
    },
    releaseAbuseResolvedPosts(postIds) {
      this.$swal({
        title: 'Are you sure?',
        html: '<b>Upon confirmation, the post will be released to client as abuse resolved.</b>',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Agree',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return PostAPI.releaseAbuseResolvePost(postIds)
            .then(data => {
              return data;
            })
            .catch(error => {
              console.error(error);
              this.$swal({
                title: 'Error in releasing Post, please try again',
                type: 'error'
              });
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Show success message
          this.$swal({
            title: 'Success',
            text: 'The abuse resolved draft is sent to client.',
            type: 'success'
          });
          // Reload Page
          // this.$router.push({ path: '/posts/pending-kobe' });
          this.$emit('input');
          this.getPosts();
          this.viewPostDialog = false;
        } else {
          // Do nothing for now
        }
      });
    },
    saleReleasePost(post) {
      if (!post.waiting_release) {
        this.$swal({
          title: 'The post is not submitted by CC yet',
          type: 'warning'
        });
      } else {
        let id = post._id;
        this.releasePosts([id]);
      }
    },
    directReleasePost(post) {
      let id = post._id;
      this.releasePosts([id]);
    },
    releasePosts(postIds) {
      let postConfirmationText = postConfig.postConfirmation.approval[this.postStatus];
      this.$swal({
        title: postConfirmationText['confirmation']['title'],
        text: postConfirmationText['confirmation']['text'],
        type: postConfirmationText['confirmation']['type'],
        showCancelButton: true,
        confirmButtonText: postConfirmationText['confirmation']['confirmText'],
        cancelButtonText: postConfirmationText['confirmation']['cancelText'],
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return PostAPI.releasePost(postIds)
            .then(data => {
              return data;
            })
            .catch(error => {
              console.error(error);
              this.$swal({
                title: 'Error in releasing Post, please try again',
                type: 'error'
              });
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Show success message
          this.$swal({
            title: postConfirmationText['confirm']['title'],
            text: postConfirmationText['confirm']['text'],
            type: 'success'
          });
          // Reload Page
          // this.$router.push({ path: '/posts/pending-client' });
          this.getPosts();
          this.$emit('input');
          this.viewPostDialog = false;
        } else {
          // Do nothing for now
        }
      });
    },
    deletePosts(postIds) {
      this.$swal({
        title: 'Are you sure?',
        text: 'Upon confirmation, the post will be deleted',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return PostAPI.bulkDeletePosts(postIds)
            .then(data => {
              return data;
            })
            .catch(error => {
              console.error(error);
              this.$swal({
                title: 'Error in deleting Post, please try again',
                type: 'error'
              });
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Show success message
          this.$swal({
            title: 'Success',
            text: 'Successfully Deleted',
            type: 'success'
          });
          // Reload Page
          // this.$router.push({ path: '/posts/pending-kobe' });
          this.$emit('input');
          this.getPosts();
          this.viewPostDialog = false;
        } else {
          // Do nothing for now
        }
      });
    },
    startSubmissionReview(post) {
      this.$router.push({ name: 'posts-submission-review', query: { id: post._id } });
    },
    submitPostPayout(post) {
      this.$router.push({ path: '/submit-post-payout', query: { id: post._id } });
    },
    enterPostURL(post) {
      CampaignAPIs.getCampaign(post.campaignID)
        .then(response => {
          this.campaignDataForAddPost = response;
          this.postIdToUpdate = post._id;
          this.addPostToCampaign = true;
          this.addPost = post
        })
        .catch(err => {
          this.addPostToCampaign = true;
          this.$swal({
            type: 'error',
            title: 'Error Getting Campaign Information'
          });
          console.log(err);
        });
    },
    assignPostURL(post) {
      let postConfirmationText = postConfig.postConfirmation.approval[this.postStatus];
      this.$swal({
        title: postConfirmationText['confirmation']['title'],
        text: postConfirmationText['confirmation']['text'],
        input: postConfirmationText['confirmation']['type'],
        inputPlaceholder: postConfirmationText['confirmation']['placeholder'],
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          PostAPI.publishPost(post._id, result.value)
            .then(() => {
              this.$swal({
                title: postConfirmationText['confirm']['title'],
                text: 'Do you want to submit payout?',
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes'
              }).then(confirmed => {
                if (confirmed.value) {
                  let payout = {
                    campaignName: post.campaignName,
                    campaignID: post.campaignID,
                    postID: post._id,
                    influencerID: post.influencerID,
                    instagramPostURL: result.value,
                    otherSocialMediaPostUrl: '',
                    satisfactionLevel: 0,
                    advertiserSatisfactionLevel: 0
                  };
                  paymentAPIs
                    .createCampaignPayout(payout)
                    .then(() => {
                      this.$swal({
                        type: 'success',
                        title: 'Campaign payout created!'
                      });
                    })
                    .catch(() => {
                      this.$swal({
                        type: 'error',
                        title: 'Cannot create campaign payout for this post. Try again later!'
                      });
                    });
                }
              });
              this.getPosts();
              // this.$router.push({ path: '/posts/published' });
            })
            .catch(() => {
              this.$swal({
                type: 'error',
                title: 'Error in processing your request! Please try again'
              });
            });
        }
      });
    },
    completePost(post) {
      let postConfirmationText = postConfig.postConfirmation.approval[this.postStatus];
      this.$swal({
        title: postConfirmationText['confirmation']['title'],
        text: postConfirmationText['confirmation']['text'],
        type: postConfirmationText['confirmation']['type'],
        confirmButtonText: postConfirmationText['confirmation']['confirmText'],
        cancelButtonText: postConfirmationText['confirmation']['cancelText'],
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          PostAPI.completePost(post._id)
            .then(() => {
              this.$swal({
                type: 'success',
                title: postConfirmationText['confirm']['title'],
                text: postConfirmationText['confirm']['text']
              }).then(() => {
                this.getPosts();
                // this.$router.push({ path: '/posts/completed' });
              });
            })
            .catch(error =>
              this.$swal({
                type: 'error',
                text: error
              })
            );
        }
      });
    },
    async markMetadataTag(ids) {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to mark as metadata tagged?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          let data = ids.map(postID => {
            return Object.assign({}, {
              id: postID,
              metadataTagged: true
            })
          })
          // Submit request to save post data
          await this.$store.dispatch('post/updatePostByIds', data)
          this.isLoading = false;
          if (!this.postUpdateStatus) {
            this.$swal({
              text: 'Error Metadata Tag.',
              type: 'error'
            });
            return
          }
          // Show success message
          this.$swal({
            text: 'Successfully Saved Metadata Tag.',
            type: 'success'
          });
          this.getPosts();
        }
      })
    },
    formatDate(date, format = 'll') {
      return moment(date).format(format);
    },
    checkAfter(date) {
      return moment(this.currentDate).isAfter(date);
    },
    checkSame(date) {
      return moment(this.currentDate).isSame(date);
    },
    fetchPost(postId, returnData) {
      PostAPI.getPostById(postId)
        .then(post => {
          this.viewPostData = post;
        })
        .catch(err => {
          this.$swal({
            title: `Couldn't the Post`,
            type: 'error',
            text: err
          });
        });
    },
    fetchPostAsync(postId, returnData) {
      return new Promise((resolve, reject) => {
        PostAPI.getPostById(postId)
        .then(post => {
          // this.viewPostData = post;
          resolve(post)
        })
        .catch(err => {
          this.$swal({
            title: `Couldn't the Post`,
            type: 'error',
            text: err
          });
          reject(err);
        });
      })
    },
    commentsInfo(comments) {
      if (comments === undefined) {
        return;
      } else {
        let commentsArr = comments.filter(comment => comment.author.id !== this.user.id);
        return commentsArr.length;
      }
    },
    viewPostByRouter() {
      // look for query parameters action for view and id to initiate the postView
      let action = this.$route.query.action;
      let id = this.$route.query.id;
      if (action === 'view' && id) {
        PostAPI.getPostById(id)
          .then(post => {
            this.viewDetailPost(post);
          })
          .catch(err => {
            this.$swal({
              title: `Couldn't the Post`,
              type: 'error',
              text: err
            });
          });
      }
    },
    changePendingConfirmation() {
      this.filter.pendingConfirmation = !this.filter.pendingConfirmation
      this.getPosts()
    },
    changeOverdueDateFilter() {
      this.filter.overdueLiveDate = !this.filter.overdueLiveDate
      this.getPosts()
    },
    changeProposeDateFilter() {
      this.filter.proposeDate = !this.filter.proposeDate
      this.getPosts()
    },
    changeEmptyLiveDateFilter() {
      this.filter.emptyLiveDate = !this.filter.emptyLiveDate
      this.getPosts()
    },
    async fetchCampaignList() {
      let response = await CampaignAPIs.getAllCampaignsNoStatus()
      let campaigns = response
      this.campaignList = campaigns.map(element => {
        return {
          name: element.name,
          id: element.id
        }
      })
    }
    // changeConfirmDateFilter() {
    //   this.filter.confirmedDate = !this.filter.confirmedDate
    //   this.getPosts()
    // }
  },
  computed: {
    user: function() {
      return this.$store.state.user;
    },
    currentUserID: function() {
      return this.$store.state.user.id;
    },
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    postStatus: function() {
      return this.$route.meta.postStatus;
    },
    isAllPosts: function() {
      return this.$route.meta.postStatus;
    },
    statuses: function() {
      let statuses = postConfig.postFilterStatuses.filter(status => status.permissions.includes(this.postStatus) || this.postStatus === -1)
      if (this.postStatus === -1) {
        statuses = statuses.filter(s => s.value !== 2)
      }
      return statuses
    },
    userRoles: function() {
      return config.userRoles;
    },
    postStatusConfig: function() {
      return config.postStatus;
    },
    currentDate: function() {
      return moment().format('ll');
    },
    paginationLength: function() {
      let round = this.totalItems / this.pagging.itemsPerPage;
      let decimal = this.totalItems % this.pagging.itemsPerPage;
      return Math.floor(round) + (decimal === 0 ? 0 : 1) || 1;
    },
    showCampaignPosts: function() {
      return this.postStatus === -1
    },
    ...mapState({
      postUpdateStatus: state => state.post.updated
    })
  },
  async mounted() {
    if (this.$route.query.handle) {
      this.filter.instagramHandle = this.$route.query.handle
    }
    if (this.$route.query.campaignID) {
      this.filter.campaignId = this.$route.query.campaignID
    }
    if (this.$route.query.postID) {
      this.filter.postID = this.$route.query.postID
    }
    await this.fetchCampaignList()
    if ((this.postStatus === -1 && (this.filter.campaignId || this.filter.postID)) || this.postStatus !== -1) {
      // get posts if not for (all posts view) or (post views with campaign or post id)
      this.getPosts();
    }
    if (this.currentUserRole !== this.userRoles.CLIENT && this.currentUserRole !== this.userRoles.INFLUENCER) {
      this.getClients();
    }
    this.display = 1
  },
  updated() {
    this.viewPostByRouter();
  }
};
</script>
<style>
  @media only screen and (min-width: 1000px) {
    .report-abuse-section,
    .report-abuse-section-edit {
      position: fixed!important;
      max-width: 270px!important;
    }
  }
</style>



// WEBPACK FOOTER //
// PostViewInternal.vue?2c195d9d